
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import TranslatedText from '@/TranslatedText';

interface SupportSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const SupportSearch = ({ searchQuery, setSearchQuery }: SupportSearchProps) => {
  return (
    <div className="max-w-2xl mx-auto mb-16">
      <div className="relative">
        <Input
          type="text"
          placeholder="Search for help..."
          className="pl-10 py-6 text-lg"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <Search className="absolute left-3 top-3 text-gray-400" />
        {searchQuery && (
          <Button 
            variant="ghost" 
            className="absolute right-2 top-2"
            onClick={() => setSearchQuery('')}
          >
            <TranslatedText text="Clear" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default SupportSearch;
